import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGear = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M31 22V18H27.74C27.55 17.27 27.26 16.58 26.89 15.94L29.2 13.63L26.37 10.8L24.06 13.11C23.42 12.73 22.73 12.45 22 12.26V9H18V12.26C17.27 12.45 16.58 12.74 15.94 13.11L13.63 10.8L10.8 13.63L13.11 15.94C12.73 16.58 12.45 17.27 12.26 18H9V22H12.26C12.45 22.73 12.74 23.42 13.11 24.06L10.8 26.37L13.63 29.2L15.94 26.89C16.58 27.27 17.27 27.55 18 27.74V31H22V27.74C22.73 27.55 23.42 27.26 24.06 26.89L26.37 29.2L29.2 26.37L26.89 24.06C27.27 23.42 27.55 22.73 27.74 22H31Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20 23C21.6569 23 23 21.6569 23 20C23 18.3431 21.6569 17 20 17C18.3431 17 17 18.3431 17 20C17 21.6569 18.3431 23 20 23Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	})]
});
const ForwardRef = forwardRef(SvgGear);
export default ForwardRef;
